import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Header, Store, Body, Brand, Details, Name, Subheader } from './TopBrands.style'
import { BlueBox, Helpers, NoResults } from '../common'
import { Arrow, Padding } from '../../../..'
import { NumberUtils } from '../../../../../utils'

const TopBrands = ({ brands, isEmpty, loading, selectedStore, t }) => (
    <BlueBox loading={loading} noResults={isEmpty}>
        <Padding fullHeight>
            <Header>
                <div>{t('Top 5 Brands')}</div>
                <Store>{selectedStore === 'all' ? 'All Stores' : selectedStore}</Store>
            </Header>
            <Body>
                {isEmpty && <NoResults />}
                {!isEmpty &&
                    brands.map(({ brand, delta, unique_visitors: visitors }, index) => {
                        const displayVisitors = NumberUtils.withDecimalsIfNeeded(visitors)

                        return (
                            <Brand key={brand}>
                                <Details>
                                    <Name>
                                        {index + 1}
                                        &#46;&nbsp;&nbsp;&nbsp;&nbsp;
                                        {brand}
                                    </Name>
                                    <Arrow direction={Helpers.transformDeltaToKey(delta)} colored />
                                </Details>
                                <Subheader>{`${displayVisitors} visitors`}</Subheader>
                            </Brand>
                        )
                    })}
            </Body>
        </Padding>
    </BlueBox>
)

TopBrands.propTypes = {
    brands: PropTypes.arrayOf(
        PropTypes.shape({
            brand: PropTypes.string,
            unique_visitors: PropTypes.number,
        })
    ),
    isEmpty: PropTypes.bool,
    loading: PropTypes.number,
    selectedStore: PropTypes.string,
    t: PropTypes.func.isRequired,
}

TopBrands.defaultProps = {
    brands: [],
    isEmpty: true,
    loading: null,
    selectedStore: null,
}

export default withTranslation()(TopBrands)
